var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 24 } },
            [
              _c("app-label", {
                staticClass: "sub-titulo",
                attrs: {
                  label: "Upload do comprovante de produtividade:",
                  required: _vm.getIsRequired
                }
              }),
              _c(
                "div",
                {
                  key: _vm.keyT + 1,
                  staticClass: "upload-area",
                  attrs: { id: _vm.id }
                },
                [
                  _c("transition", { attrs: { name: "idle-fade" } }, [
                    !_vm.loading && !_vm.success
                      ? _c(
                          "div",
                          {
                            staticClass: "content content-idle",
                            class: { "error-upload": _vm.errors.length }
                          },
                          [
                            _c("div", { staticClass: "info" }, [
                              _vm._v(
                                "Arraste e solte ou clique para selecionar um arquivo."
                              )
                            ]),
                            _c("div", { staticClass: "format" }, [
                              _vm._v(
                                "Formato(s) suportado(s): " +
                                  _vm._s(this.fileType.join(", "))
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "transition",
                    { attrs: { name: "width-enter-active" } },
                    [
                      _vm.loading
                        ? _c(
                            "el-row",
                            {
                              staticClass: "content content-loader",
                              style: {
                                width:
                                  (_vm.percentage < 20
                                    ? 20
                                    : _vm.percentage
                                  ).toString() + "%"
                              }
                            },
                            [
                              _c(
                                "el-col",
                                { staticClass: "column", attrs: { span: 12 } },
                                [
                                  _c("div", { staticClass: "arquivo-info" }, [
                                    _c("div", { staticClass: "name" }, [
                                      _vm._v(_vm._s(_vm.fileName))
                                    ]),
                                    _c("div", { staticClass: "size" }, [
                                      _vm._v(_vm._s(_vm.fileSize) + " Kb")
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "transition",
                                { attrs: { name: "buttons-and-label-fade" } },
                                [
                                  _vm.success && _vm.percentage === 100
                                    ? _c(
                                        "el-col",
                                        { staticClass: "column right" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "label loadingSucess"
                                            },
                                            [_vm._v("Carregado com sucesso!")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  !_vm.success && _vm.loading
                    ? _c("span", { staticClass: "progress" }, [
                        _vm._v(_vm._s(_vm.percentage) + "%")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c("transition", { attrs: { name: "buttons-and-label-fade" } }, [
                _vm.success
                  ? _c(
                      "div",
                      { staticClass: "buttons buttonsDuble" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "excluir",
                            attrs: { size: "small", name: "excluir" },
                            on: { click: _vm.excluir }
                          },
                          [
                            _c("span", { staticClass: "center" }, [
                              _c("i", { staticClass: "fa fa-times" }),
                              _c("b", [_vm._v("  Remover")])
                            ])
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "anexar",
                            attrs: { size: "small", name: "anexar" },
                            on: { click: _vm.anexar }
                          },
                          [
                            _c("span", { staticClass: "center" }, [
                              _c("i", { staticClass: "fal fa-paperclip" }),
                              _c("b", [_vm._v("  Anexar")])
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("app-resumable", {
                key: _vm.keyT,
                ref: _vm.id,
                attrs: {
                  target: _vm.target,
                  fileType: _vm.fileType,
                  idDrop: _vm.id,
                  idInput: _vm.id,
                  fileTypeErrorCallback: _vm.fileTypeErrorCallback,
                  maxSize: _vm.maxSize || null
                },
                on: {
                  onSuccess: _vm.onSuccessEvent,
                  onError: _vm.onErrorEvent,
                  onProgress: _vm.onProgressEvent,
                  fileAdded: _vm.onFileAddedEvent
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5c8a8ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5c8a8ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/AppUploadDocumentosDestinacaoUsoImovel.vue
// module id = null
// module chunks = 